/* unplugin-vue-components disabled */import script from "./header.vue?vue&type=script&lang=ts&setup=true"
export * from "./header.vue?vue&type=script&lang=ts&setup=true"

import "./header.vue?vue&type=style&index=0&id=3b14b2fe&lang=less&scoped=true"

import exportComponent from "D:\\HBuilderProjects\\quyizu-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b14b2fe"]])

export default __exports__